import React from 'react'
import { Controller, UseFieldArrayProps } from 'react-hook-form'

import TextInput from 'APP/Converse/Inputs/TextInput'
import { KeyboardTypeOptions, TextInputProps } from 'react-native'
import { baseColors } from 'APP/Theme/Theme'
import { IconVariantProps } from 'APP/Converse/Icon/types'

interface ControllerInputProps {
  control: UseFieldArrayProps['control']
  name: string
  rules?: UseFieldArrayProps['rules']
  autoFocus?: boolean
  autoCapitalize?: TextInputProps['autoCapitalize']
  testID?: string
  label: string
  isFocused?: boolean
  infotip?: string
  keyboardType?: KeyboardTypeOptions
  onFocus?: () => void
  disabled?: boolean
  isSecureEntry?: boolean
  placeholder?: string
  hide?: boolean
  autoCorrect?: boolean
  spellCheck?: boolean
  showRequiredAsterisk?: boolean
  onPressIn?: TextInputProps['onPressIn']
  id?: string
  icon?: string
  iconPosition?: 'left' | 'right'
  iconVariant?: IconVariantProps
  iconColor?: keyof typeof baseColors
  iconSize?: number
  noBottomMargin?: boolean
}

const ControllerInput = ({
  control,
  name,
  rules,
  autoFocus,
  autoCapitalize,
  testID,
  label,
  isFocused,
  infotip,
  keyboardType = 'default',
  onFocus,
  disabled,
  isSecureEntry,
  placeholder,
  hide,
  autoCorrect,
  spellCheck,
  showRequiredAsterisk,
  onPressIn,
  id,
  icon,
  iconPosition,
  iconVariant,
  iconColor,
  iconSize,
  noBottomMargin,
}: ControllerInputProps) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => (
        <TextInput
          disabled={disabled}
          ref={ref}
          autoFocus={autoFocus}
          autoCapitalize={autoCapitalize}
          testID={testID}
          onChangeText={onChange}
          value={value}
          onBlur={onBlur}
          onFocus={onFocus}
          returnKeyType="default"
          label={label}
          showRequiredAsterisk={showRequiredAsterisk}
          onPressIn={onPressIn}
          error={error?.message}
          keyboardType={keyboardType}
          isSecureEntry={isSecureEntry}
          isFocused={isFocused}
          infotip={infotip}
          placeholder={placeholder}
          hide={hide}
          spellCheck={spellCheck}
          autoCorrect={autoCorrect}
          accessibilityLabel={label}
          id={id}
          icon={icon}
          iconPosition={iconPosition}
          iconVariant={iconVariant}
          iconColor={iconColor}
          iconSize={iconSize}
          noBottomMargin={noBottomMargin}
        />
      )}
    />
  )
}

export default ControllerInput
